import * as React from 'react'
import * as st from './badge.module.scss'
import { safeBoolean } from '../../utils/utils'

export interface HdrBadgeProps {
  isHdr?: boolean
}

//TODO: AVWebDetailPage-2972
export const Hdr = ({ isHdr }: HdrBadgeProps) => (
  safeBoolean(isHdr) &&
  (<span className={st.borderedTextBadge}>
    <span data-automation-id="hdr-badge">HDR</span>
  </span>) || null
)
